import PropTypes from 'prop-types'
import { renderRoutes } from 'react-router-config'

const SubscribersPage = (props) => {
  return renderRoutes(props.route.routes)
}

SubscribersPage.propTypes = {
  route: PropTypes.any,
  history: PropTypes.any,
  location: PropTypes.any,
}

export default SubscribersPage
